import React from "react";
import { render } from "react-dom";

// import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import MainApp from "./MainApp";

import { Provider } from 'react-redux';
import store from './Store';
import { persistor } from './Store';
import { PersistGate } from 'redux-persist/integration/react';

import axios from 'axios';
import join from 'url-join';

import { TOKEN_LOAD, REFRESH_LOAD } from './Actions/types';


import DocumentMeta from 'react-document-meta';

import { pinkA200, grey100, grey300, grey400, grey500, white, darkBlack, fullBlack } from 'material-ui/styles/colors';



const muiTheme = getMuiTheme({
    fontFamily: 'Open Sans',
    palette: {
        textColor: darkBlack,
        primary1Color: darkBlack,
        primary2Color: darkBlack,
        primary3Color: grey400,
        accent1Color: pinkA200,
        accent2Color: grey100,
        accent3Color: grey500,
        alternateTextColor: white,
        canvasColor: white,
        borderColor: grey300,
        disabledColor: grey500,
        pickerHeaderColor: darkBlack,
        clockCircleColor: grey300,
        shadowColor: fullBlack,
    },
    appBar: {
        height: 50,
    },
});

let negotiating = false;
let retryed = 0;


axios.interceptors.request.use(function (config) {

    console.log(process.env.REACT_APP_API_URL)

    var isAbsoluteURLRegex = /^(?:\w+:)\/\//;
    if ( !isAbsoluteURLRegex.test(config.url) ) {
        config.url = join(process.env.REACT_APP_API_URL, config.url);
    }

    // TMP
    // const action = {
    //     type: TEXT_CHANGED,
    //     payload: 'DESDE INTERCEPTORS'
    //   }
    // store.dispatch(action)
    // TMP

    var token = store.getState().auth_reducer.token;
    if (token) {
        config.headers['authorization'] = 'Bearer ' + token;
    }

  // config.headers['X-Requested-With'] = 'XMLHttpRequest';
  // config.headers['Expires'] = '-1';
  // config.headers['Cache-Control'] = "no-cache,no-store,must-revalidate,max-age=-1,private";

    return config;

}, function (err) {

  return Promise.reject(err);
});


axios.interceptors.response.use((response) => {
    return response;
}, function (error) {

    const originalRequest = error.config;

    if (error.response.status === 401) {
        console.log('401 unauthorized');

        window.location.href = '/me/logout';

        originalRequest._retry = true;

        // persistor.purge();

        if(!negotiating){
        // if(store.getState().auth_reducer.negotiating==false){

            negotiating = true;
            console.log('Negotiating...');

            // const refreshToken = window.localStorage.getItem('refreshToken');
            const refreshToken = store.getState().auth_reducer.refresh;
            const userId = store.getState().auth_reducer.user.id;

            return axios.post(process.env.REACT_APP_API_URL + 'auth/token/negotiate', {
                userId: userId,
                refreshToken: refreshToken
            })
            .then(({data}) => {


                const action = {
                    type: TOKEN_LOAD,
                    payload: data.token
                }
                store.dispatch(action)

                const actionRefresh = {
                    type: REFRESH_LOAD,
                    payload: data.refresh
                }
                store.dispatch(actionRefresh)

                // window.localStorage.setItem('token', data.token);
                // window.localStorage.setItem('refreshToken', data.refreshToken);
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
                originalRequest.headers['Authorization'] = 'Bearer ' + data.token;

                negotiating = false;

                return axios(originalRequest);

            });


        }
        else{
            retryed++;

            if(retryed===3){
                console.log('No more retrys.');
                persistor.purge();
                window.location.href = '/me/logout';
            }

            console.log('Retrying ' + retryed + '...');

            setTimeout(function() {

                originalRequest.headers['Authorization'] = 'Bearer ' + store.getState().auth_reducer.token;

                axios(originalRequest);

            }, 1000);


        }



    }

    return Promise.reject(error.response);

});






function App() {

    const meta = {
         title: 'HUB',
         description: 'Agencia Ego HUB - Endpoint para carga de horas',
         canonical: 'http://tudia.agenciaego.com.ar',
         meta: {
           charset: 'utf-8',
           name: {
             keywords: 'react,meta,horas,ego,plan'
           }
         }
       };


  return (
    <MuiThemeProvider muiTheme={muiTheme}>
        <DocumentMeta {...meta}>
            <MainApp />
        </DocumentMeta>
    </MuiThemeProvider>
  )
}

render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>

            <App />

        </PersistGate>
    </Provider>, document.querySelector("#app")
);




// WEBPACK FOOTER //
// ./src/index.js